export default function () {
    initSlider();

    window.addEventListener("resize", function () {
        updateSlider();
    });

    function initSlider() {
        $('.js-reviews-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    function updateSlider() {
        if (!$('.js-reviews-slider').hasClass('slick-initialized')) {
            initSlider();
        }
    }
}
